// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FdJm","col":"styles_col__9wxKi","actions":"styles_actions__1wo4D","conflict":"styles_conflict__1RxLF"};